module.exports = __webpack_public_path__ + "static/media/jjp-online-training-2020.eeffa679.mp4";